import React, {Component} from "react";

import Bitacora from "./LogView";
import {LogService} from "../../../service/admin/log/LogService";
import {Growl} from "primereact/growl";

export default class LogContainer extends Component {
    constructor(props) {
        super(props);

        this.logService = new LogService();

        this.handleContextMenu = this.handleContextMenu.bind(this);
        this.onChangeFilters = this.onChangeFilters.bind(this);
        this.clearFilters = this.clearFilters.bind(this);
        this.onPage = this.onPage.bind(this);
        this.getLog = this.getLog.bind(this);
        this.today = new Date();

        this.state = {
            isLoading: false,
            anchorEl: null,
            filters: {
                startDate: this.today,
                finalDate: this.today,
                today: this.today,
                catUserFilter: {}
            },
            logList: [],
            first: 0,
            rows: 15,
        };
    }

    loading(isLoading) {
        if (this.state !== undefined) {
            this.setState({
                isLoading: isLoading
            });
        }
    }

    onChangeFilters(event) {
        let filtersAux = this.state.filters;
        if (event.target.name === "startDate") {
            filtersAux[event.target.name] = event.target.value;
            filtersAux['finalDate'] = event.target.value;
        } else {
            filtersAux[event.target.name] = event.target.value ? event.target.value : "";
        }
        this.setState({
            filters: filtersAux,
        });
    }

    clearFilters() {
        this.setState({
            filters: {
                startDate: this.today,
                finalDate: this.today,
                today: this.today,
                catUserFilter: {}
            },
        });
    }

    handleContextMenu(option) {
        if (this.state.logList.length === 0) {
            this.growl.show({
                severity: 'info', summary: 'Atención.',
                detail: "No existen Registros"
            });
        } else {
            this.loading(true)
            this.logService.exportLog(option, this.state.filters)
                .then(response => {
                    this.loading(false);
                });
        }
    }

    onPage(event) {
        this.setState({
            first: event.first,
        });
        this.getLog();
    }

    getLog() {
        this.loading(true);
        this.logService.getLog(this.state.first, this.state.rows, this.state.filters).then(response => {
            if (response.payload.length === 0) {
                this.growl.show({
                    severity: 'info', summary: 'Atención.',
                    detail: "No existen Registros"
                });
            }
            this.setState({
                logList: response.payload,
                totalRecords: response.payload.length > 0 ? response.payload[0].totalRegistros : 0,
            });
            this.loading(false);
        });
    }

    render() {
        let exportOptions = [
            {
                label: "PDF", action: () => {
                    this.handleContextMenu("PDF")
                }
            },
            {
                label: "Excel", action: () => {
                    this.handleContextMenu("XLS")
                }
            },
        ];

        let messagesGrowl = <Growl ref={(el) => this.growl = el}/>;

        return <Bitacora
            isLoading={this.state.isLoading}
            loading={this.loading}
            filters={this.state.filters}
            logList={this.state.logList}
            getLog={this.getLog}
            first={this.state.first}
            onPage={this.onPage}
            rows={this.state.rows}
            totalRecords={this.state.totalRecords}
            onChangeFilters={this.onChangeFilters}
            messagesGrowl={messagesGrowl}
            clearFilters={this.clearFilters}
            exportOptions={exportOptions}
        />
    }
};